import React, { useState } from 'react';
import '../styles/Avatar.css';

const Avatar = ({
  user,
  size = 'md',
  className = ''
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleError = () => {
    setImageError(true);
  };

  const handleLoad = () => {
    setImageLoaded(true);
  };

  const getProfilePictureUrl = () => {
    if (!user) return null;

    const userId = user._id || user.id;
    if (!userId) return null;

    const agencyId = user.agency_id;

    if (agencyId) {
      return `/api/profile-picture/${userId}/${agencyId}`;
    }
    return `/api/profile-picture/${userId}`;
  };

  const profilePictureUrl = getProfilePictureUrl();
  const showImage = profilePictureUrl && !imageError;
  const showFallback = !showImage || !imageLoaded;

  return (
    <div className={`avatar avatar-${size} ${className}`}>
      {showImage && (
        <img
          src={profilePictureUrl}
          alt={user.name || user.email}
          className={`avatar-img ${imageLoaded ? 'loaded' : 'loading'}`}
          onError={handleError}
          onLoad={handleLoad}
          referrerPolicy="no-referrer"
        />
      )}

      {showFallback && (
        <div className="avatar-fallback">
          <span className="avatar-icon">👤</span>
        </div>
      )}
    </div>
  );
};

export default Avatar;
